/* unplugin-vue-components disabled */import script from "./CardComp.vue?vue&type=script&setup=true&lang=js"
export * from "./CardComp.vue?vue&type=script&setup=true&lang=js"

import "./CardComp.vue?vue&type=style&index=0&id=571a0c16&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-571a0c16"]])

export default __exports__